import set from 'lodash/set';
import get from 'lodash/get';
import keys from 'lodash/keys';

import {
  COUNTRIES,
} from '../../../constants/countries';
import getCardTypeFromNumber from '../../utils/getCardTypeFromNumber';

import trimInputSpaces from '../../utils/trim-input-spaces';

export default function payoutCardMutations(formData, key, value) {
  const nextValue = trimInputSpaces(value);

  set(formData, key, nextValue);

  switch (key) {
    case 'cardNumber':
      set(formData, 'cardType', getCardTypeFromNumber(formData.cardNumber));
      break;

    case 'countryAbbreviation':
      set(formData, 'city', '');
      set(formData, 'zipCode', '');
      set(formData, 'state', keys(get(COUNTRIES[value], 'states'))[0]);
      break;

    default:
  }

  return formData;
}
